<!------------ START TEMPLATE ------------>
<template>
  <div>
    <!------------ START FORM ------------>
    <form role="form" @submit.stop.prevent="onSubmit">
      <!-----============================ OBS: No status deve ter um campo SELECT que irá trazer as opções criadas pelo usuário na parte cadastro de Status do Menu USUARIO  ==================------->
      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Ativo</span>
          <vs-switch
            color="success"
            v-model="formCadastro.status"
            style="width: 60px"
          >
            <span slot="on">Ativo</span>
            <span slot="off">Inativo</span>
          </vs-switch>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Nome</span>
          <vs-input
            size="large"
            class="w-full"
            name="Nome"
            id="Nome"
            v-model="formCadastro.nome"
            v-validate="{ required: true, min: 6 }"
            :state="validateState('Nome')"
            :danger="validateClass('Nome')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Estado</span>
          <v-select
            :options="estados"
            name="Estado"
            id="Estado"
            v-model="estado"
            @selected="buscaDadosSelectsCidades"
            :state="validateState('Estado')"
            :class="validateClass('Estado')"
          ></v-select>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Cidade</span>
          <v-select
            :options="cidades"
            name="Cidade"
            id="Cidade"
            v-model="formCadastro.cidade"
            :state="validateState('Cidade')"
            :class="validateClass('Cidade')"
          ></v-select>
        </div>
      </div>

      <div class="vx-row mb-6" v-if="integracoes.length > 0">
        <div class="vx-col w-full">
          <span>Integração SGA</span>
          <v-select
            :options="integracoes"
            name="Integração"
            id="Integração"
            v-model="formCadastro.integracao"
            :state="validateState('Integração')"
            :class="validateClass('Integração')"
          ></v-select>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Gerar Cobrança Automatica de Adesão / 1 Parcela</span>
          <vs-switch
            color="success"
            v-model="formCadastro.geraCobrancaAdesaoAutomatica"
            style="width: 60px"
          >
            <span slot="on">Sim</span>
            <span slot="off">Não</span>
          </vs-switch>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Gerar Cobrança antes da Vistoria</span>
          <vs-switch
            color="success"
            v-model="formCadastro.cobrancaValoresAntesDaVistoria"
            style="width: 60px"
          >
            <span slot="on">Sim</span>
            <span slot="off">Não</span>
          </vs-switch>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Permite pagamento da 1 Parcela no cartão de Crédito</span>
          <vs-switch
            color="success"
            v-model="formCadastro.permitePagamentoCartaoCreditoAdesao"
            style="width: 60px"
          >
            <span slot="on">Sim</span>
            <span slot="off">Não</span>
          </vs-switch>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Permite pagamento da Mensalidade no cartão de Crédito</span>
          <vs-switch
            color="success"
            v-model="formCadastro.permitePagamentoCartaoCreditoMensalidade"
            style="width: 60px"
          >
            <span slot="on">Sim</span>
            <span slot="off">Não</span>
          </vs-switch>
        </div>
      </div>

      <!--- START REGIONAL RAIZ --->
      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Regional raiz</span>
          <vs-switch
            color="success"
            v-model="formCadastro.isRegionalRaiz"
            style="width: 60px"
          >
            <span slot="on">Sim</span>
            <span slot="off">Não</span>
          </vs-switch>
        </div>
      </div>

      <div class="vx-row mb-6" v-if="carteiras.length > 0">
        <div class="vx-col w-full">
          <vs-select
            v-if="carteiras"
            v-model="formCadastro.idCarteira"
            id="Carteira de Cobrança"
            label="Carteira de Cobrança"
            class="select-large w-full"
            name="Carteira de Cobrança"
            :state="validateState('Carteira de Cobrança')"
            :class="validateClass('Carteira de Cobrança')"
          >
            <vs-select-item :key="0" :value="null" :text="'Selecione'" />
            <vs-select-item
              :key="`carteira-${index}`"
              :value="item.id"
              :text="`${item.label}`"
              v-for="(item, index) in carteiras"
            />
          </vs-select>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Permite placa duplicado:</span>
          <vs-switch
            color="success"
            v-model="formCadastro.permitePlacaDuplicada"
            style="width: 60px"
          >
            <span slot="on">Sim</span>
            <span slot="off">Não</span>
          </vs-switch>
        </div>
      </div>

      <div
        class="vx-row"
        v-if="$can('Alterar valores de comissão regional', 'Cotações')"
      >
        <div class="vx-col mb-6 w-full">
          <span>Valor Min. Comissão:</span>
          <vs-input
            class="w-full mb-6"
            name="valorMinimoComissao"
            id="valorMinimoComissao"
            v-model="formCadastro.valorMinimoComissao"
            @input="validateMinimoComissao"
            :danger="errors.valorMinimoComissao !== ''"
            :danger-text="errors.valorMinimoComissao"
            icon-pack="feather"
            icon="icon-percent"
            icon-no-border
            icon-after
            type="number"
            step="1"
          />

          <span>Valor Max. Comissão:</span>
          <vs-input
            class="w-full"
            name="valorMaximoComissao"
            id="valorMaximoComissao"
            v-model="formCadastro.valorMaximoComissao"
            @input="validateMaximoComissao"
            :danger="errors.valorMaximoComissao !== ''"
            :danger-text="errors.valorMaximoComissao"
            icon-pack="feather"
            icon="icon-percent"
            icon-no-border
            icon-after
            type="number"
          />
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col mb-6 w-full">
          <span>Meta padrão para novos consultores</span>
          <vs-input
            class="w-full"
            name="metaPadraoConsultor"
            id="metaPadraoConsultor"
            v-model="formCadastro.metaPadraoConsultor"
            type="number"
          />
        </div>
      </div>
      <div class="vx-row mb-3">
        <div class="vx-col w-full p-4">
          <div class="vx-col flex gap-2 items-center mt-2">
            <span class="mb-1">Adicionar apólice</span>
            <vs-button
              color="warning"
              type="filled"
              icon="add"
              @click.stop.prevent="abrirFormCadastrarApolice()"
            ></vs-button>
          </div>

          <br />
          <vs-list-item
            v-for="apolice in formCadastro.apolices"
            :key="apolice.numeroApolice"
            :title="apolice.nomeContrato"
            :subtitle="apolice.numeroApolice"
          >
            <!-- <vs-button
              class="text-default"
              radius
              v-tooltip="'Detalhes'"
              color="primary"
              type="gradient"
              icon-pack="feather"
              icon="icon-search"
              @click.stop.prevent="detalhesApolice(item)"
            ></vs-button> -->

            <template slot="avatar">
              <div class="flex">
                <vs-button
                  @click.stop.prevent="editarApolice(apolice)"
                  class="mr-2 text-default"
                  color="primary"
                  type="border"
                  icon="edit"
                ></vs-button>
                <vs-button
                  @click.stop.prevent="deletarApolice(apolice)"
                  class="mr-2 text-default"
                  color="danger"
                  type="border"
                  icon="clear"
                ></vs-button>
              </div>
            </template>
          </vs-list-item>
        </div>
      </div>
      <!--- END REGIONAL RAIZ --->

      <!--- START CORRETORA ATIVA --->
      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Corretora Regional</span>
          <vs-switch
            color="success"
            v-model="formCadastro.corretoraRegional"
            style="width: 60px"
          >
            <span slot="on">Sim</span>
            <span slot="off">Não</span>
          </vs-switch>
        </div>
      </div>
      <div v-if="formCadastro.corretoraRegional">
        <div class="vx-row">
          <div class="vx-col mb-6">
            <span>Exibir no Certificado?</span>
            <vs-switch
              color="success"
              v-model="formCadastro.corretoraAtiva"
              style="width: 60px"
            >
              <span slot="on">Sim</span>
              <span slot="off">Não</span>
            </vs-switch>
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col mb-6 w-full">
            <span>Nome da Corretora</span>
            <vs-input
              class="w-full"
              size="large"
              name="Nome da Corretora"
              id="nomeCorretora"
              v-validate="{
                required: formCadastro.corretoraRegional,
                min: 4,
                max: 255,
              }"
              :state="validateState('nomeCorretora')"
              :danger="validateClass('nomeCorretora')"
              icon-pack="feather"
              icon="icon-user"
              icon-no-border
              v-model="formCadastro.nomeCorretora"
            />
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col mb-6 w-full">
            <span>Codigo SUSEP</span>
            <vs-input
              class="w-full"
              type="number"
              size="large"
              name="Codigo SUSEP"
              id="codigoSUSEP"
              v-model="formCadastro.codigoSUSEP"
              :state="validateState('codigoSUSEP')"
              :danger="validateClass('codigoSUSEP')"
              v-validate="{ required: formCadastro.corretoraRegional, max: 15 }"
              icon-pack="feather"
              icon="icon-code"
              icon-no-border
            />
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col mb-6 w-full">
            <span>Email da Corretora</span>
            <vs-input
              class="w-full"
              size="large"
              name="Email da Corretora"
              id="emailCorretora"
              type="email"
              v-validate="{ email: true }"
              v-model="formCadastro.emailCorretora"
              :state="validateState('emailCorretora')"
              :danger="validateClass('emailCorretora')"
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
              icon-pack="feather"
              icon="icon-mail"
              icon-no-border
            />
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col mb-6 w-full">
            <span>Telefone</span>
            <vs-input
              class="w-full"
              size="large"
              name="Numero de telefone da Corretora"
              id="telefoneCorretora"
              v-validate="{ min: 15 }"
              v-model="formCadastro.telefoneCorretora"
              :state="validateState('telefoneCorretora')"
              :danger="validateClass('telefoneCorretora')"
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
              v-mask="'(##) #####-####'"
              icon-pack="feather"
              icon="icon-phone"
              icon-no-border
            />
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col mb-6 w-full">
            <span>Celular</span>
            <vs-input
              class="w-full"
              size="large"
              name="Numero de telefone da Corretora"
              id="celularCorretora"
              v-validate="{ min: 15 }"
              v-model="formCadastro.numeroCorretora"
              :state="validateState('celularCorretora')"
              :danger="validateClass('celularCorretora')"
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
              v-mask="'(##) #####-####'"
              icon-pack="feather"
              icon="icon-smartphone"
              icon-no-border
            />
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col mb-6 w-full">
            <span>CPF/CNPJ</span>
            <vs-input
              class="w-full"
              size="large"
              name="CPF/CNPJ Corretora"
              id="documentCorretora"
              v-validate="{ required: formCadastro.corretoraRegional, min: 14 }"
              :state="validateState('documentCorretora')"
              :danger="validateClass('documentCorretora')"
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
              v-mask="cpfCnpjMask"
              icon-pack="feather"
              icon="icon-user-check"
              icon-no-border
              @input="updateMask"
              v-model="formCadastro.documentCorretora"
            />
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col w-full">
            <span>CEP</span>
            <vs-input
              size="large"
              class="w-full"
              name="Cep da corretora"
              id="CepCorretora"
              @keyup.native="getAddress(true)"
              v-model="formCadastro.enderecoCorretora.cepCorretora"
              v-validate="{ required: formCadastro.corretoraRegional, min: 10 }"
              :state="validateState('CepCorretora')"
              :danger="validateClass('CepCorretora')"
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
              v-mask="'##.###-###'"
              icon-pack="feather"
              icon="icon-home"
              icon-no-border
            />
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col mb-6 w-full">
            <span>Endereço</span>
            <vs-input
              class="w-full"
              size="large"
              name="Endereço da Corretora"
              id="EnderecoCorretora"
              v-model="formCadastro.enderecoCorretora.enderecoCorretora"
              v-validate="{ required: formCadastro.corretoraRegional, min: 6 }"
              :state="validateState('EnderecoCorretora')"
              :danger="validateClass('EnderecoCorretora')"
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
              icon-pack="feather"
              icon="icon-map-pin"
              icon-no-border
            />
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col w-full">
            <span>Número</span>
            <vs-input
              size="large"
              class="w-full"
              name="Numero do endereço da Corretora"
              id="NumeroCorretoraEndereco"
              v-model="formCadastro.enderecoCorretora.numeroEnderecoCorretora"
              v-validate="{ required: formCadastro.corretoraRegional, max: 10 }"
              :state="validateState('NumeroCorretoraEndereco')"
              :danger="validateClass('NumeroCorretoraEndereco')"
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
              icon-pack="feather"
              icon="icon-check-circle"
              icon-no-border
            />
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col w-full">
            <span>Complemento</span>
            <vs-input
              size="large"
              class="w-full"
              name="Complemento da Corretora"
              id="ComplementoCorretora"
              v-model="formCadastro.enderecoCorretora.complementoCorretora"
              :state="validateState('Complemento')"
              :danger="validateClass('Complemento')"
              v-validate="{ max: 100 }"
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
              icon-pack="feather"
              icon="icon-check-circle"
              icon-no-border
            />
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col w-full">
            <span>Bairro</span>
            <vs-input
              size="large"
              class="w-full"
              name="Bairro da Corretora"
              id="BairroCorretora"
              v-model="formCadastro.enderecoCorretora.bairroCorretora"
              v-validate="{ required: formCadastro.corretoraRegional }"
              :state="validateState('BairroCorretora')"
              :danger="validateClass('BairroCorretora')"
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
              icon-pack="feather"
              icon="icon-map-pin"
              icon-no-border
            />
          </div>
        </div>

        <!-----============================ OBS: API CORREIOS  ==================------->
        <div class="vx-row mb-6">
          <div class="vx-col w-full">
            <span>Cidade</span>
            <vs-input
              size="large"
              class="w-full"
              name="Cidade da Corretora"
              id="CidadeCorretora"
              v-model="formCadastro.enderecoCorretora.cidadeCorretora"
              v-validate="{ required: formCadastro.corretoraRegional, min: 3 }"
              :state="validateState('CidadeCorretora')"
              :danger="validateClass('CidadeCorretora')"
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
              icon-pack="feather"
              icon="icon-map"
              icon-no-border
            />
          </div>
        </div>

        <!-----============================ OBS: API CORREIOS  ==================------->
        <div class="vx-row mb-6">
          <div class="vx-col w-full">
            <span>Estado</span>
            <vs-input
              size="large"
              class="w-full"
              name="Estado da Corretora"
              id="EstadoCorretora"
              v-model="formCadastro.enderecoCorretora.estadoCorretora"
              v-validate="{
                required: formCadastro.corretoraRegional,
                min: 2,
                max: 2,
              }"
              :state="validateState('EstadoCorretora')"
              :danger="validateClass('EstadoCorretora')"
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
              icon-pack="feather"
              icon="icon-navigation"
              icon-no-border
            />
          </div>
        </div>
      </div>

      <vs-alert
        v-if="$validator.errors.all().length > 0"
        color="danger"
        title="Atenção!!"
        active="true"
        class="my-3"
        style="height: auto !important"
      >
        <ul>
          <li
            class="mb-2"
            v-for="error in $validator.errors.all()"
            :key="error.id"
          >
            {{ error }}
          </li>
        </ul>
      </vs-alert>
      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button
            color="warning"
            type="border"
            class="mr-3 mb-2"
            @click.stop.prevent="onReset"
            >Cancelar</vs-button
          >
          <BotaoSubmit
            variant="success"
            :edit="!this.dados.idRegional"
            :aguarde="aguardeCadastro"
            :disabled="
              (formCadastro.corretoraRegional &&
                $validator.errors.all().length > 0) ||
              $validator.errors.all().length > 0
            "
          ></BotaoSubmit>
        </div>
      </div>

      <vs-popup
        class="holamundo"
        title="Cadastrar apólice"
        :active.sync="activePromptApolice"
        @cancel="clearFormCadastrarApolice"
        @close="clearFormCadastrarApolice"
      >
        <div>
          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <div class="flex gap-3">
                <!-- Dados Apólice -->

                <div class="vx-col w-full">
                  <span>Nome do contrato</span>
                  <vs-input
                    size="large"
                    class="w-full"
                    name="nomeContrato"
                    id="nomeContrato"
                    v-model="nomeContrato"
                  />
                </div>

                <div class="vx-col w-full">
                  <span>Número da apólice</span>
                  <vs-input
                    size="large"
                    class="w-full"
                    name="numeroApolice"
                    id="numeroApolice"
                    v-model="numeroApolice"
                  />
                </div>
              </div>
              <br />
            </div>
          </div>

          <vs-button
            color="success"
            class="w-full mt-2"
            @click="adicionarApolice"
            >Adicionar</vs-button
          >
        </div>
      </vs-popup>
    </form>
    <!------------ END FORM ------------>
  </div>
</template>
<!------------ END TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import locale from './../../locale';

import * as lang from 'vuejs-datepicker/src/locale';
import vSelect from 'vue-select';
import service from '../../services';
import BotaoSubmit from '../../components/BotaoSubmit';
import { decryptData } from '@/services/decryptData';

export default {
  props: {
    sideBar: {
      type: Boolean,
    },
    dados: {
      type: Object,
    },
  },
  computed: {
    cpfCnpjMask() {
      return this.currentMask;
    },
  },
  watch: {
    dados() {
      this.preencheForm();
    },
    estado(value) {
      this.formCadastro.estado = value;
      this.formCadastro.cidade = null;
      this.buscaDadosSelectsCidades(
        'domMunicipio',
        'cidades',
        'nomeCidade',
        'idCidade',
      );
    },
  },
  data() {
    return {
      aguardeCadastro: false,
      idEmpresa: null,
      estados: [],
      cidades: [],
      integracoes: [],
      languages: lang,
      estado: null,
      funcoesValicao: null,
      carteiras: [],
      formCadastro: {
        idRegional: null,
        idEmpresa: null,
        integracao: null,
        idCarteira: null,
        status: true,
        nome: '',
        cidade: '',
        estado: '',
        geraCobrancaAdesaoAutomatica: null,
        cobrancaValoresAntesDaVistoria: null,
        permitePagamentoCartaoCreditoAdesao: null,
        permitePagamentoCartaoCreditoMensalidade: null,
        permitePlacaDuplicada: null,
        apolices: [],
        apolicesExcluidas: [],
        valorMinimoComissao: 0,
        valorMaximoComissao: 0,
        metaPadraoConsultor: null,
        isRegionalRaiz: false,
        corretoraRegional: false,
        corretoraAtiva: false,
        emailCorretora: null,
        codigoSUSEP: null,
        telefoneCorretora: null,
        nomeCorretora: null,
        numeroCorretora: null,
        documentCorretora: null,
        enderecoCorretora: {
          enderecoCorretora: null,
          numeroEnderecoCorretora: null,
          complementoCorretora: null,
          bairroCorretora: null,
          cidadeCorretora: null,
          estadoCorretora: null,
          cepCorretora: null,
        },
      },
      nomeContrato: null,
      numeroApolice: null,
      activePromptApolice: false,
      numeroApoliceSelecionada: null,
      errors: {
        valorMinimoComissao: '',
        valorMaximoComissao: '',
      },
      minValue: 0,
      maxValue: 25,
      cpfMask: '###.###.###-##',
      cnpjMask: '##.###.###/####-##',
      currentMask: '###.###.###-##',
    };
  },
  methods: {
    getAddress(isCorretora = false) {
      const LENGTH_CEP = 10;
      if (
        this.formCadastro.enderecoCorretora.cepCorretora.length === LENGTH_CEP
      ) {
        this.$vs.loading();
        const cepFormat = this.formCadastro.enderecoCorretora.cepCorretora
          .replace('.', '')
          .replace('-', '');
        service
          .post('g', 'BuscaCEP', {
            cep: cepFormat,
          })
          .then((res) => {
            res.data = decryptData(res.data);
            if (isCorretora) {
              this.formCadastro.enderecoCorretora.enderecoCorretora =
                res.data.street;
              this.formCadastro.enderecoCorretora.bairroCorretora =
                res.data.neighborhood;
              this.formCadastro.enderecoCorretora.cidadeCorretora =
                res.data.city;
              this.formCadastro.enderecoCorretora.estadoCorretora =
                res.data.state;
              this.$vs.loading.close();
              return;
            }
            this.formCadastro.endereco = res.data.street;
            this.formCadastro.bairro = res.data.neighborhood;
            this.formCadastro.cidade = res.data.city;
            this.formCadastro.estado = res.data.state;
            this.$vs.loading.close();
          })
          .catch(() => {
            this.$vs.loading.close();
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'Não Foi possível encontrar o cep',
              color: 'danger',
            });
          });
      }
    },
    updateMask() {
      const DOCUMENT_CPF = 11;
      if (
        this.formCadastro.documentCorretora.replace(/\D/g, '').length >
        DOCUMENT_CPF
      ) {
        this.currentMask = this.cnpjMask;
        return;
      }
      this.currentMask = this.cpfMask;
    },
    preencheForm() {
      if (this.dados.idRegional) {
        this.formCadastro.idRegional = this.dados.idRegional;
        this.formCadastro.idCarteira = this.dados.idCarteira;
        this.formCadastro.status = this.dados.deletedAt == null ? true : false;
        this.formCadastro.nome = this.dados.nome;
        this.formCadastro.cidade = this.dados.cidade;
        this.formCadastro.estado = this.dados.estado;
        this.formCadastro.geraCobrancaAdesaoAutomatica =
          this.dados.geraCobrancaAdesaoAutomatica;
        this.formCadastro.cobrancaValoresAntesDaVistoria =
          this.dados.cobrancaValoresAntesDaVistoria;
        this.formCadastro.permitePagamentoCartaoCreditoAdesao =
          this.dados.permitePagamentoCartaoCreditoAdesao;
        this.formCadastro.permitePagamentoCartaoCreditoMensalidade =
          this.dados.permitePagamentoCartaoCreditoMensalidade;
        this.formCadastro.permitePlacaDuplicada =
          this.dados.permitePlacaDuplicada;
        if (this.estados.length > 0) {
          this.estado = this.estados.find((x) => x.label == this.dados.estado);
        }
        if (this.integracoes.length > 0) {
          this.formCadastro.integracao = this.integracoes.find(
            (x) => x.id == this.dados.idIntegracao,
          );
        }

        this.formCadastro.enderecoCorretora.enderecoCorretora =
          this.dados.enderecoCorretora;
        this.formCadastro.enderecoCorretora.bairroCorretora =
          this.dados.bairroCorretora;
        this.formCadastro.enderecoCorretora.cidadeCorretora =
          this.dados.cidadeCorretora;
        this.formCadastro.enderecoCorretora.estadoCorretora =
          this.dados.estadoCorretora;
        this.formCadastro.enderecoCorretora.cepCorretora =
          this.dados.cepCorretora;
        this.formCadastro.enderecoCorretora.complementoCorretora =
          this.dados.complementoCorretora;
        this.formCadastro.enderecoCorretora.numeroEnderecoCorretora =
          this.dados.numeroEnderecoCorretora;

        this.formCadastro.corretoraRegional = this.dados.corretoraRegional;
        this.formCadastro.corretoraAtiva = this.dados.corretoraAtiva;
        this.formCadastro.emailCorretora = this.dados.emailCorretora;
        this.formCadastro.codigoSUSEP = this.dados.codigoSUSEP;
        this.formCadastro.nomeCorretora = this.dados.nomeCorretora;
        this.formCadastro.numeroCorretora = this.dados.numeroCorretora;
        this.formCadastro.telefoneCorretora = this.dados.telefoneCorretora;
        this.formCadastro.documentCorretora = this.dados.documentCorretora;

        this.formCadastro.apolices = this.dados.apolices;
        this.formCadastro.valorMinimoComissao = this.dados.valorMinimoComissao;
        this.formCadastro.valorMaximoComissao = this.dados.valorMaximoComissao;
        this.formCadastro.isRegionalRaiz = this.dados.isRegionalRaiz;
      } else {
        this.resetForm();
      }
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    async onSubmit() {
      this.formCadastro.idEmpresa = this.idEmpresa;

      const action = this.formCadastro.idRegional ? 'Atualizar' : 'Adicionar';
      const msgRetorno = this.formCadastro.idRegional
        ? 'Dados Atualizados com sucesso'
        : 'Registro Adicionado com sucesso';

      try {
        await this.$validator.validateAll();
        this.aguardeCadastro = true;

        this.updateValuesMinMaxToNumber();
        this.$emit('concluido');

        await service.post('Regional', action, this.formCadastro);

        this.aguardeCadastro = false;
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: msgRetorno,
          color: 'success',
        });

        this.$emit('concluido');
      } catch (error) {
        this.aguardeCadastro = false;
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: (error && error.message) || 'Ocorreu um erro desconhecido.',
          color: 'danger',
        });
      }
    },
    updateValuesMinMaxToNumber() {
      this.formCadastro.valorMinimoComissao = parseInt(
        this.formCadastro.valorMinimoComissao,
        10,
      );
      this.formCadastro.valorMaximoComissao = parseInt(
        this.formCadastro.valorMaximoComissao,
        10,
      );
    },
    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll('g', {}, `${model}/list/`).then((res) => {
        res.data = decryptData(res.data);
        res.data.forEach((element) => {
          this[array].push({
            id: element[campoPK],
            label: element[campoDescricao],
          });
        });
      });
    },
    buscaDadosSelectsPorEmpresa(model, array, campoDescricao, campoPK) {
      service
        .getAll('g', {}, `${model}/list/idEmpresa/idEmpresa=${this.idEmpresa}`)
        .then((res) => {
          res.data = decryptData(res.data);
          res.data.forEach((element) => {
            element.id = element[campoPK];
            element.label = element[campoDescricao];
            this[array].push(element);
          });
          console.log(this[array]);
        });
    },
    buscaIntegracoes() {
      service
        .getAll('IntegracaoSGA', {}, 'list/idEmpresa=' + this.idEmpresa)
        .then((res) => {
          res.data.forEach((element) => {
            this.integracoes.push({
              id: element.idIntegracao,
              label: element.nome,
            });
          });
        });
    },
    buscaDadosSelectsCidades(model, array, campoDescricao, campoPK) {
      if (this.formCadastro.estado) {
        this.$vs.loading();
        this[array] = [];
        service
          .getAll('g', {}, `${model}/list/codUf/${this.formCadastro.estado.id}`)
          .then((res) => {
            res.data = decryptData(res.data);
            res.data.forEach((element) => {
              this[array].push({
                id: element[campoPK],
                label: element[campoDescricao],
              });
            });
            if (this.formCadastro.cidade != '') {
              this.formCadastro.cidade = this[array].find(
                (x) => x.label == this.dados.cidade,
              );
            }

            this.$vs.loading.close();
          });
      }
    },
    resetForm() {
      this.formCadastro = {
        idRegional: null,
        idEmpresa: null,
        status: true,
        integracao: null,
        nome: '',
        cidade: '',
        estado: '',
        geraCobrancaAdesaoAutomatica: null,
        cobrancaValoresAntesDaVistoria: null,
        permitePagamentoCartaoCreditoAdesao: null,
        permitePagamentoCartaoCreditoMensalidade: null,
        permitePlacaDuplicada: null,
        apolices: [],
        apolicesExcluidas: [],
        valorMinimoComissao: 0,
        valorMaximoComissao: 0,
        isRegionalRaiz: false,
        corretoraRegional: false,
        corretoraAtiva: false,
        emailCorretora: null,
        codigoSUSEP: null,
        nomeCorretora: null,
        telefoneCorretora: null,
        numeroCorretora: null,
        documentCorretora: null,
        enderecoCorretora: {
          endereco: null,
          numero: null,
          complemento: null,
          bairro: null,
          cidade: null,
          estado: null,
          cep: null,
        },
      };

      this.nomeContrato = null;
      this.numeroApolice = null;
      this.activePromptApolice = null;
      this.numeroApoliceSelecionada = null;
    },
    onReset(evt) {
      if (this.sideBar == true) {
        this.$emit('cancel');
      } else {
        evt.preventDefault();
        this.resetForm();
        this.$nextTick(() => {
          this.show = true;
        });
      }
    },
    abrirFormCadastrarApolice() {
      this.activePromptApolice = true;
    },
    clearFormCadastrarApolice() {
      this.activePromptApolice = false;
      this.nomeContrato = null;
      this.numeroApolice = null;
      this.numeroApoliceSelecionada = null;
    },
    adicionarApolice() {
      const adicionarApolice = this.nomeContrato && this.numeroApolice;
      const editarApolice = this.numeroApoliceSelecionada && adicionarApolice;

      if (editarApolice) {
        const indexApolice = this.formCadastro.apolices.findIndex(
          (apolice) => apolice.numeroApolice === this.numeroApoliceSelecionada,
        );

        const apoliceEditada = {
          ...this.formCadastro.apolices[indexApolice],
          nomeContrato: this.nomeContrato,
          numeroApolice: this.numeroApolice,
        };

        this.formCadastro.apolices[indexApolice] = apoliceEditada;

        this.clearFormCadastrarApolice();
        return;
      }

      if (adicionarApolice) {
        this.formCadastro.apolices.push({
          nomeContrato: this.nomeContrato,
          numeroApolice: this.numeroApolice,
        });

        this.clearFormCadastrarApolice();

        return;
      }
    },
    editarApolice(apolice) {
      this.activePromptApolice = true;
      this.numeroApoliceSelecionada = apolice.numeroApolice;
      this.nomeContrato = apolice.nomeContrato;
      this.numeroApolice = apolice.numeroApolice;
    },
    deletarApolice(apolice) {
      const index = this.formCadastro.apolices.findIndex(
        (apoliceItem) => apoliceItem.numeroApolice === apolice.numeroApolice,
      );

      const [apoliceExcluida] = this.formCadastro.apolices.splice(index, 1);

      this.formCadastro.apolicesExcluidas.push(apoliceExcluida);
      this.clearFormCadastrarApolice();
    },
    validateMinimoComissao() {
      const min = this.formCadastro.valorMinimoComissao;
      const isOutOfRange = min < this.minValue || min > this.maxValue;
      if (isOutOfRange) {
        const errorMessage = `Valor deve ser entre ${this.minValue} e ${this.maxValue}.`;
        this.errors.valorMinimoComissao = errorMessage;
        return;
      }
      this.errors.valorMinimoComissao = '';
    },
    validateMaximoComissao() {
      const max = this.formCadastro.valorMaximoComissao;
      const min = this.formCadastro.valorMinimoComissao;
      const isMaxLessThanMin = max < min;
      if (isMaxLessThanMin) {
        const errorMessage = 'Valor máximo não pode ser menor que o mínimo.';
        this.errors.valorMaximoComissao = errorMessage;
        return;
      }
      const isMaxGreaterThanAllowed = max > this.maxValue;
      if (isMaxGreaterThanAllowed) {
        const errorMessage = `Valor não pode ser maior que ${this.maxValue}.`;
        this.errors.valorMaximoComissao = errorMessage;
        return;
      }

      this.errors.valorMaximoComissao = '';
    },
  },
  mounted() {
    this.buscaDadosSelects('domUf', 'estados', 'nomeUf', 'codUf');
    this.buscaIntegracoes();
    this.buscaDadosSelectsPorEmpresa(
      'empresasCarteiraCobranca',
      'carteiras',
      'nomeCarteira',
      'idCarteira',
    );
    //this.buscaDadosSelects("domMunicipio", "cidades", "nomeCidade", "idCidade");
    this.$validator.localize('ptBr', locale);
  },
  components: {
    BotaoSubmit,
    'v-select': vSelect,
  },
};
</script>
<!------------ END SCRIPT ------------>
